(ns app.front.ui.termination-info
  (:require [app.front.ui.rich-text :as ui-rt]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]
            [core.user.model :as user-model]))

(defn banner
  "Shared terminal-state presentation. Attribution, heading and body may be independently absent.

   `:border-color` is a Tailwind border colour class, or \"none\" (the default) for no stripe."
  [{:keys [title heading body attribution border-color data-cy]
    :or   {border-color "none"}}]
  [:div.p-6.px-8.bg-white.rounded
   {:class   (when (and border-color (not= border-color "none"))
               ["border-l-8 border-solid" border-color])
    :data-cy data-cy}
   [:h2.pb-6.font-semibold title]
   (when heading [:h3.pb-2.font-semibold.text-base heading])
   body
   (when attribution
     [:div.mt-4.pt-4.border-t.border-solid.border-ui-gray.flex.items-start.gap-3.text-gray-600
      (cc/icon {:icon i/user :description "" :aria-hidden true :class-name "shrink-0"})
      [:p.py-0 attribution]])])

(defn termination-info
  "Banner shown on top of the workspace when a phase has been terminated.

  Pass `:rich-text-reason?` when the reason attribute holds rich text rather than plain text."
  [entity {:keys [tr reason-attr by-attr ts-attr descr-tr-key rich-text-reason? border-color]
           :or   {border-color "none"}}]
  (when (contains? entity ts-attr)
    (let [reason    (reason-attr entity)
          date-time (<sub [::date-util/date-time-fn])]
      [banner {:border-color border-color
               :title        (tr [(:domain/state entity)])
               :heading      (tr [reason-attr])
               :body         (if rich-text-reason?
                               [ui-rt/editor {:id                 (str "termination-reason-" (name reason-attr))
                                              :initial-html-value reason}]
                               [:p reason])
               :attribution  (tr [descr-tr-key]
                                 [(user-model/full-name (by-attr entity))
                                  (-> entity ts-attr date-time)])}])))
